exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btnSubmit{float:right}.inputFile{display:-ms-flexbox;display:flex;width:100%;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:10px}.subTxtRight{float:right;font-size:16px}.addbnt{float:right}.dataWarning{color:red;font-weight:600}.tableCompare thead,.tableCompare tbody tr{display:table;width:100%;table-layout:fixed}.tableCompare tbody{display:block;max-height:300px;overflow-y:auto}.alternative_cb{float:right;margin-right:5px;background-color:#f2f1f0}.alternative_cb label{margin-bottom:unset;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.alternative_cb label input{margin:0 4px}#error-msgs{padding:10px;display:none;color:red;font-weight:bold;text-align:right}.add_suggestion{position:absolute;width:350px;height:200px;overflow:auto;background-color:aliceblue;border:1px solid gray;z-index:999}.add_suggestion>li{border-bottom:1px solid gray;padding:5px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/compare/add.scss
// module id = 1531
// module chunks = 0